import ScrollReveal from "@/components/base/ScrollReveal";

export default function TargetAudienceSection() {
  const audiences = [
    "保單很多，但不知道保障是否重複或不足的人",
    "想為家庭建立醫療、意外、長照、重大傷病防線的人",
    "想規劃教育金、退休金與傳承安排的人",
    "有資產配置需求，但擔心市場波動與風險的人",
    "企業主、負責人、合夥人、主管",
    "想讓錢與保障系統化，而不是零散處理的人",
  ];

  return (
    <section className="py-20 md:py-28 bg-brand-black relative">
      <div
        className="absolute bottom-0 right-0 w-[300px] h-[300px] rounded-full opacity-10"
        style={{
          background: "radial-gradient(circle, #D4AF37 0%, transparent 70%)",
        }}
      />

      <div className="container-main relative z-10">
        {/* Section Title */}
        <ScrollReveal className="text-center mb-14 md:mb-16">
          <h2 className="text-white font-display font-bold text-[1.5rem] md:text-[2.125rem] leading-[1.4] mb-4">
            誰適合找保險門神？
          </h2>
          <div className="w-[60px] h-[2px] bg-brand-gold mx-auto" />
        </ScrollReveal>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {audiences.map((text, index) => (
            <ScrollReveal key={index} delay={index * 80}>
              <div
                className="bg-brand-card border border-brand-border rounded-xl p-5 md:p-6 flex items-start gap-3 h-full"
              >
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-brand-gold/15 text-brand-gold font-bold text-[0.875rem] shrink-0 mt-0.5">
                  {index + 1}
                </span>
                <p className="text-brand-text-secondary text-[1.0625rem] leading-[1.75]">
                  {text}
                </p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
